import React, { Component } from "react";
import Lightbox from "react-image-lightbox";

class GaleriaJuniorDoble extends Component {
  constructor(props) {
    super(props);
    this.state = {
      photoIndex: 0,
      isOpen: false
    };
  }
  render() {
    const images = [
      "assets/img/jr-suite-doble/jr-suite-doble-hermosillo-2.jpg",
      "assets/img/jr-suite-doble/jr-suite-doble-hermosillo-4.jpg",
      "assets/img/jr-suite-doble/jr-suite-doble-hermosillo-6.jpg",
      "assets/img/jr-suite-doble/jr-suite-doble-hermosillo-8.jpg",
      "assets/img/jr-suite-doble/jr-suite-doble-hermosillo-10.jpg",
      "assets/img/jr-suite-doble/jr-suite-doble-hermosillo-12.jpg",
      "assets/img/jr-suite-doble/jr-suite-doble-hermosillo-14.jpg",
      "assets/img/jr-suite-doble/jr-suite-doble-hermosillo-16.jpg",
      "assets/img/jr-suite-doble/jr-suite-doble-hermosillo-18.jpg",
      "assets/img/jr-suite-doble/jr-suite-doble-hermosillo-20.jpg"
    ];
    let imageItems = images.map((image, i) => {
      return (
        <div className="col-lg-4 col-md-4 col-sm-6">
          <div className="gd-item">
            <img src={image} alt="" />
            <a
              onClick={() => this.setState({ isOpen: true, photoIndex: i })}
              title=""
              className="html5lightbox zoom-img-3"
            >
              <img src="/assets/images/zoom.png" alt="" />
            </a>
          </div>
        </div>
      );
    });
    const { photoIndex, isOpen } = this.state;
    return (
      <div
        className="tab-pane fade"
        id="tab4"
        role="tabpanel"
        aria-labelledby="tab_4"
      >
        <div className="gallery-grid">
          <div className="row">{imageItems}</div>
        </div>
        {isOpen && (
          <Lightbox
            mainSrc={images[photoIndex]}
            nextSrc={images[(photoIndex + 1) % images.length]}
            prevSrc={images[(photoIndex + images.length - 1) % images.length]}
            onCloseRequest={() => this.setState({ isOpen: false })}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex: (photoIndex + images.length - 1) % images.length
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex: (photoIndex + 1) % images.length
              })
            }
          />
        )}
      </div>
    );
  }
}
export default GaleriaJuniorDoble;
